
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12">
  <path
    d="M12 1.64999H4.5V0L0.750008 2.25L4.5 4.5V2.84999H12C14.25 2.84999 15.9 4.34999 15.9 6.75C15.9 9.15001 14.25 10.65 12 10.65H7.50001C7.2 10.65 6.9 10.95 6.9 11.25C6.9 11.55 7.2 11.85 7.50001 11.85H12C14.85 11.85 17.1 9.82499 17.1 6.75C17.1 3.67501 14.85 1.64999 12 1.64999Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'GoBack',
    }) as DefineComponent
    </script>
    